import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EquipoDialogModel,
  EquipoModel,
} from 'src/app/models/solicitud/EquipoModel';
import {
  PersonalDialogModel,
  PersonalModel,
} from 'src/app/models/solicitud/PersonalModel';
import {
  VehiculoDialogModel,
  VehiculoModel,
} from 'src/app/models/solicitud/VehiculoModel';

import { SolicitudContratistaService } from 'src/app/services/solicitud-contratista/solicitud-contratista.service';
import { RegistrarEquipoDialogComponent } from '../../equipo/registrar-equipo-dialog/registrar-equipo-dialog.component';
import { RegistrarPersonalDialogComponent } from '../../personal/registrar-personal-dialog/registrar-personal-dialog.component';
import { RegistrarVehiculoDialogComponent } from '../../vehiculo/registrar-vehiculo-dialog/registrar-vehiculo-dialog.component';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import {
  DocumentoTipoRequisito,
  EstadoDocumentoItem,
  EstadoSolicitud,
  SolicitudSeccion,
  eTypeResult,
} from 'src/app/models/common/enumModel';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';
import * as fileSaver from 'file-saver';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import { SolicitudEquipoService } from 'src/app/services/solicitud-equipo/solicitud-equipo.service';
import { SolicitudVehiculoService } from 'src/app/services/solicitud-vehiculo/solicitud-vehiculo.service';
import { ListaDocumentoTecnicoRegistrarModel } from 'src/app/models/solicitud/documento/ListaDocumentoTecnicoRegistrarModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-solicitud-contratista-completar',
  templateUrl: './solicitud-contratista-completar.component.html',
  styleUrls: ['./solicitud-contratista-completar.component.css'],
})
export class SolicitudContratistaCompletarComponent implements OnInit {
  public itemSolicitud: ISolicitudModel;
  // listaSedes: SedeModel[] = new Array<SedeModel>();
  // listaTipoVisita: TipoVisitaModel[] = new Array<TipoVisitaModel>();
  displayedColumnsPersonal: string[] = [
    'nombre',
    'nroDocumentoIdentidad',
    'correo',
    'cargo',
    'cantidad_documentos',
    'estado',
    'acciones',
  ];
  displayedColumnsEquipos: string[] = [
    'equipo',
    'marca',
    'modelo',
    'serie',
    'estado',
    'acciones',
  ];
  displayedColumnsVehiculos: string[] = [
    'marca',
    'modelo',
    'placa',
    'color',
    'anio',
    'chofer',
    'estado',
    'acciones',
  ];
  displayedColumnsDocumentosTecnicos: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'estado',
    'acciones',
  ];

  id: number;
  public comentarioDocumentacionTecnica: string = '';
  @ViewChild('tablePersonal') tablePersonal!: MatTable<any>;
  @ViewChild('tableEquipos') tableEquipos!: MatTable<any>;
  // @ViewChild('tableEquipos', { static: true, read:MatTable }) tableEquipos!: MatTable<any>;
  @ViewChild('tableVehiculos') tableVehiculos!: MatTable<any>;
  // @ViewChild('tableVehiculos', { static: true, read:MatTable }) tableVehiculos!: MatTable<any>;
  isNewRecord: boolean = false;
  permiteEnviar: boolean = false;
  constructor(
    private route: ActivatedRoute,
    // private sedeService: SedeService,
    // private tipoVisitaService: TipoVisitaService,
    private solicitudService: SolicitudService,
    private solicitudContratistaService: SolicitudContratistaService,
    private solicitudDocumentoTecnicoService: SolicitudDocumentosTecnicosService,
    private solicitudPersonaService: SolicitudPersonaService,
    private solicitudEquipoService: SolicitudEquipoService,
    private solicitudVehiculoService: SolicitudVehiculoService,
    public dialog: MatDialog,
    private router: Router,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) {
    this.itemSolicitud = new SolicitudModel();
    this.id = 0;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.getSolicitud();
  }

  getSolicitud(): void {
    this.solicitudService
      .getById(this.id)
      .subscribe((data: ISolicitudModel) => {
        this.itemSolicitud = data;

        this.itemSolicitud.lista_documentos_personal =
          data.documentosRequeridos.filter(
            (p) => p.seccion == SolicitudSeccion.Personal
          );
        this.itemSolicitud.lista_documentos_equipos =
          data.documentosRequeridos.filter(
            (p) => p.seccion == SolicitudSeccion.Equipos
          );
        this.itemSolicitud.lista_documentos_vehiculos =
          data.documentosRequeridos.filter(
            (p) => p.seccion == SolicitudSeccion.Vehiculos
          );

        this.itemSolicitud.logs = this.itemSolicitud.logs.filter(p => p.comentarios != "" && p.comentarios != null);
        this.itemSolicitud.logsDocumentacionTecnica = this.itemSolicitud.logsDocumentacionTecnica.filter(p => p.comentarios != "");
        // this.itemSolicitud.lista_documentos_tecnicos =
        //   data.documentosRequeridos.filter(
        //     (p) => p.seccion == SolicitudSeccion.DocumentacionTecnica
        //   );

        // this.itemSolicitud.aplicaEquipos = true;
        // this.itemSolicitud.aplicaVehiculos = true;
        // this.itemSolicitud.aplicaDocumentacionTecnica = true;

        if (this.itemSolicitud.idEstado == EstadoSolicitud.SOLICITADO) {
          this.permiteEnviar = true;
          this.displayedColumnsPersonal = this.displayedColumnsPersonal.filter(
            (p) => p !== 'estado'
          );
          this.displayedColumnsEquipos = this.displayedColumnsEquipos.filter(
            (p) => p !== 'estado'
          );
          this.displayedColumnsVehiculos =
            this.displayedColumnsVehiculos.filter((p) => p !== 'estado');

          this.displayedColumnsDocumentosTecnicos =
            this.displayedColumnsDocumentosTecnicos.filter(
              (p) => p !== 'estado'
            );

          this.itemSolicitud.documentosTecnicos.forEach((p) => {
            if (!p.idEstado) {
              p.idEstado = EstadoDocumentoItem.PENDIENTE;
            }
          });
          this.comentarioDocumentacionTecnica = "";
          // this.itemSolicitud.lista_documentos_tecnicos.forEach((p) => {
          //   if (!p.idEstado) {
          //     p.idEstado = EstadoDocumentoItem.PENDIENTE;
          //   }
          // });
        }
        else if (this.itemSolicitud.idEstado == EstadoSolicitud.OBSERVADO)
          this.permiteEnviar = true;
        else if (this.itemSolicitud.idEstado == EstadoSolicitud.EN_REVISION) {
          if (this.itemSolicitud.idEstadoDocumentacionTecnica == 2
            || this.itemSolicitud.personas.some(p => p.idEstado == EstadoDocumentoItem.OBSERVADO)
            || this.itemSolicitud.equipos.some(p => p.idEstado == EstadoDocumentoItem.OBSERVADO)
            || this.itemSolicitud.vehiculos.some(p => p.idEstado == EstadoDocumentoItem.OBSERVADO))
            this.permiteEnviar = true;
        }
      });
  }

  deletePersona(element: PersonalModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud a ${element.nombres} ${element.apellidoPaterno} ${element.apellidoMaterno}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudPersonaService.eliminar(element.idSolicitudPersona).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteEquipo(element: EquipoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el equipo: ${element.equipo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudEquipoService.eliminar(element.idSolicitudEquipo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteVehiculo(element: VehiculoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el vehículo: ${element.marca}-${element.modelo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudVehiculoService.eliminar(element.idSolicitudVehiculo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteDocTecnico(element: SolicitudDocumentoTecnicoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el archivo del documento: ${element.documento}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudDocumentoTecnicoService.eliminar(element.idSolicitudDocumentoTecnico).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  openDialogPersonal(personal?: PersonalModel): void {
    if (!personal) {
      personal = new PersonalModel();
      this.isNewRecord = true;
    } else {
      this.isNewRecord = false;
      personal.idTipoDocumentoIdentidadSelected =
        personal.idTipoDocumentoIdentidad;
    }

    if (this.itemSolicitud.idEstado == EstadoSolicitud.SOLICITADO) {
      personal.documentos.forEach((p) => {
        if (!p.idEstado) p.idEstado = EstadoDocumentoItem.PENDIENTE;
      });
    }

    personal.idSolicitud = this.itemSolicitud.idSolicitud;
    personal.idSede = this.itemSolicitud.idSede;
    personal.idContratista = this.itemSolicitud.idContratista;
    personal.codigoSolicitud = this.itemSolicitud.codigo;
    personal.enableEdit =
      this.itemSolicitud.idEstado === EstadoSolicitud.SOLICITADO ||
      this.itemSolicitud.idEstado === EstadoSolicitud.OBSERVADO;

    let dialog = new PersonalDialogModel();
    dialog.persona = personal;
    dialog.documentacionRequerida =
      this.itemSolicitud.lista_documentos_personal;
    dialog.enableEdit =
      this.itemSolicitud.idEstado === EstadoSolicitud.SOLICITADO ||
      this.itemSolicitud.idEstado === EstadoSolicitud.OBSERVADO;

    dialog.documentacionRequerida.forEach((element) => {
      let index = dialog.persona.documentos.findIndex(
        (p) =>
          p.idSolicitudDocumentoRequerido ==
          element.idSolicitudDocumentoRequerido
      );
      // console.log(index);
      if (index == -1 && !element.esAdicional) {
        let documento = new DocumentacionRequeridaModel();
        documento.controlarFechas = element.controlarFechas;
        documento.documento = element.documento;
        documento.esRequisitoBloqueado = element.esRequisitoBloqueado;
        documento.idDocumento = element.idDocumento;
        documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        documento.idRequisito = element.idRequisito;
        documento.idSolicitudDocumentoRequerido =
          element.idSolicitudDocumentoRequerido;
        documento.requisito = element.requisito;
        documento.restringeAccesos = element.restringeAccesos;
        documento.seccion = element.seccion;
        documento.contieneDocumento = false;
        documento.nombreArchivo = '';
        dialog.persona.documentos.push(documento);
      }
    });

    const dialogRef = this.dialog.open(RegistrarPersonalDialogComponent, {
      width: '1000px',
      data: dialog,
    });

    dialogRef.afterClosed().subscribe((result: PersonalDialogModel) => {
      // if (result) {
      //   if (this.isNewRecord) {
      //     // result.persona.documentos = result.persona.documentos.filter(
      //     //   (p) => p.contieneDocumento === true
      //     // );
      //     this.itemSolicitud.personas.push(result.persona);
      //     this.tablePersonal.renderRows();
      //   }
      // }
      this.getSolicitud();
    });
  }

  openDialogEquipo(equipo?: EquipoModel): void {
    if (!equipo) {
      equipo = new EquipoModel();
      this.isNewRecord = true;
    } else {
      this.isNewRecord = false;
    }

    if (this.itemSolicitud.idEstado == EstadoSolicitud.SOLICITADO) {
      equipo.documentos.forEach((p) => {
        if (!p.idEstado) {
          p.idEstado = EstadoDocumentoItem.PENDIENTE;
        }
      });
    }

    equipo.idSolicitud = this.itemSolicitud.idSolicitud;
    equipo.codigoSolicitud = this.itemSolicitud.codigo;

    equipo.enableEdit =
      this.itemSolicitud.idEstado === EstadoSolicitud.SOLICITADO ||
      this.itemSolicitud.idEstado === EstadoSolicitud.OBSERVADO;

    let dialog = new EquipoDialogModel();
    dialog.equipo = equipo;
    dialog.documentacionRequerida = this.itemSolicitud.lista_documentos_equipos;
    dialog.enableEdit =
      this.itemSolicitud.idEstado === EstadoSolicitud.SOLICITADO ||
      this.itemSolicitud.idEstado === EstadoSolicitud.OBSERVADO;

    dialog.documentacionRequerida.forEach((element) => {
      let index = dialog.equipo.documentos.findIndex(
        (p) =>
          p.idSolicitudDocumentoRequerido ==
          element.idSolicitudDocumentoRequerido
      );
      if (index == -1 && !element.esAdicional) {
        let documento = new DocumentacionRequeridaModel();
        documento.controlarFechas = element.controlarFechas;
        documento.documento = element.documento;
        documento.esRequisitoBloqueado = element.esRequisitoBloqueado;
        documento.idDocumento = element.idDocumento;
        documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        documento.idRequisito = element.idRequisito;
        documento.idSolicitudDocumentoRequerido =
          element.idSolicitudDocumentoRequerido;
        documento.requisito = element.requisito;
        documento.restringeAccesos = element.restringeAccesos;
        documento.seccion = element.seccion;

        dialog.equipo.documentos.push(documento);
      }
    });

    const dialogRef = this.dialog.open(RegistrarEquipoDialogComponent, {
      width: '1000px',
      data: dialog,
    });

    dialogRef.afterClosed().subscribe((result: EquipoDialogModel) => {
      // if (result) {
      //   if (this.isNewRecord) {
      //     // result.equipo.documentos = result.equipo.documentos.filter(
      //     //   (p) => p.contieneDocumento === true
      //     // );
      //     this.itemSolicitud.equipos.push(result.equipo);

      //     this.tableEquipos.renderRows();
      //   }
      // }
      this.getSolicitud();
    });
  }

  openDialogVehiculo(vehiculo?: VehiculoModel): void {
    if (!vehiculo) {
      vehiculo = new VehiculoModel();
      this.isNewRecord = true;
    } else {
      this.isNewRecord = false;
    }

    if (this.itemSolicitud.idEstado == EstadoSolicitud.SOLICITADO) {
      vehiculo.documentos.forEach((p) => {
        if (!p.idEstado) {
          p.idEstado = EstadoDocumentoItem.PENDIENTE;
        }
      });
    }

    vehiculo.idSolicitud = this.itemSolicitud.idSolicitud;
    vehiculo.codigoSolicitud = this.itemSolicitud.codigo;

    vehiculo.enableEdit =
      this.itemSolicitud.idEstado === EstadoSolicitud.SOLICITADO ||
      this.itemSolicitud.idEstado === EstadoSolicitud.OBSERVADO;

    let dialog = new VehiculoDialogModel();
    dialog.vehiculo = vehiculo;
    dialog.documentacionRequerida = this.itemSolicitud.lista_documentos_vehiculos;
    dialog.enableEdit =
      this.itemSolicitud.idEstado === EstadoSolicitud.SOLICITADO ||
      this.itemSolicitud.idEstado === EstadoSolicitud.OBSERVADO;

    dialog.documentacionRequerida.forEach((element) => {
      let index = dialog.vehiculo.documentos.findIndex(
        (p) =>
          p.idSolicitudDocumentoRequerido ==
          element.idSolicitudDocumentoRequerido
      );
      if (index == -1 && !element.esAdicional) {
        let documento = new DocumentacionRequeridaModel();
        documento.controlarFechas = element.controlarFechas;
        documento.documento = element.documento;
        documento.esRequisitoBloqueado = element.esRequisitoBloqueado;
        documento.idDocumento = element.idDocumento;
        documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        documento.idRequisito = element.idRequisito;
        documento.idSolicitudDocumentoRequerido =
          element.idSolicitudDocumentoRequerido;
        documento.requisito = element.requisito;
        documento.restringeAccesos = element.restringeAccesos;
        documento.seccion = element.seccion;

        dialog.vehiculo.documentos.push(documento);
      }
    });

    const dialogRef = this.dialog.open(RegistrarVehiculoDialogComponent, {
      width: '1000px',
      data: dialog,
    });

    dialogRef.afterClosed().subscribe((result: VehiculoDialogModel) => {
      // if (result) {
      //   if (this.isNewRecord) {
      //     // result.vehiculo.documentos = result.vehiculo.documentos.filter(
      //     //   (p) => p.contieneDocumento === true
      //     // );
      //     this.itemSolicitud.vehiculos.push(result.vehiculo);

      //     this.tableVehiculos.renderRows();
      //   }
      // }
      this.getSolicitud();
    });
  }

  guardarDocumentosTecnicos() {

    console.log(this.itemSolicitud.documentosTecnicos);

    let documentosObligatorios = this.itemSolicitud.documentosTecnicos.filter(
      (p) =>
      (
        p.idRequisito == DocumentoTipoRequisito.TODOS &&
        (
          p.nombreArchivo == '' ||
          (p.controlarFechas === true && !p.fechaVencimiento)
        )
      )
    );

    if (documentosObligatorios.length > 0) {
      this.alertDialogService.open('Debe ingresar los documentos o fechas de vencimiento obligatorios');
    } else {
      let modelLista = new ListaDocumentoTecnicoRegistrarModel();
      modelLista.idSolicitud = this.itemSolicitud.idSolicitud;
      modelLista.documentos = this.itemSolicitud.documentosTecnicos;
      modelLista.comentarios = this.comentarioDocumentacionTecnica;
      this.solicitudDocumentoTecnicoService.submitMultiple(modelLista).subscribe((result) => {
        console.log(result);
        this.getSolicitud();
      });
    }
  }

  enviarSolicitud() {
    if (!this.esInvalido()) {
      this.confirmDialogService.open('Se enviará la documentación para revisión ¿Está seguro?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.solicitudService.completar(this.itemSolicitud).subscribe((p) => {
            this.alertDialogService.open('La solicitud fue enviada para su revisión.');
            this.router.navigate(['/solicitudes-contratista']);
          });
        }
      });
    }
  }

  closed() {
    this.confirmDialogService.open('Se perderan los cambios no guardados ¿Está seguro de salir?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.router.navigate(['/solicitudes-contratista']);
      }
    });
  }

  esInvalido(): boolean {
    let mensage = '';
    let errores = 0;
    if (this.itemSolicitud.aplicaPersonas && this.itemSolicitud.personas.length == 0) {
      mensage += 'Debe registrar por lo menos una persona\n';
      errores++;
    }

    if (
      this.itemSolicitud.aplicaEquipos &&
      this.itemSolicitud.equipos.length == 0
    ) {
      mensage += 'Debe registrar por lo menos un equipo\n';
      errores++;
    }

    if (
      this.itemSolicitud.aplicaVehiculos &&
      this.itemSolicitud.vehiculos.length == 0
    ) {
      mensage += 'Debe registrar por lo menos un vehiculo\n';
      errores++;
    }

    if (
      this.itemSolicitud.aplicaDocumentacionTecnica &&
      this.itemSolicitud.documentosTecnicos.filter(
        (p) =>
          p.nombreArchivo !== null && p.nombreArchivo !== ''
      ).length == 0
    ) {
      mensage += 'Debe registrar por lo menos un documento técnico\n';
      errores++;
    }

    if (this.itemSolicitud.aplicaDocumentacionTecnica) {
      let documentosTecnicosRequeridos =
        this.itemSolicitud.documentosTecnicos.filter(
          (p) =>
            p.idRequisito == DocumentoTipoRequisito.TODOS
          // || p.controlarFechas
        );

      let documentosTecnicosObligatoriosRegistrados =
        this.itemSolicitud.documentosTecnicos.filter(
          (p) =>
            p.idRequisito == DocumentoTipoRequisito.TODOS &&
            p.nombreArchivo !== null && p.nombreArchivo !== ''
            &&
            ((p.controlarFechas === true && p.fechaVencimiento) ||
              !p.controlarFechas)
        );

      if (
        documentosTecnicosRequeridos.length >
        documentosTecnicosObligatoriosRegistrados.length
      ) {
        mensage +=
          'Debe registrar los documentos técnicos obligatorios y/o fechas de vencimiento requeridos\n';
        errores++;
      }
    }

    if (!this.itemSolicitud.aplicaPersonas && !this.itemSolicitud.aplicaEquipos && !this.itemSolicitud.aplicaVehiculos && !this.itemSolicitud.aplicaDocumentacionTecnica) {
      mensage +=
        'Debe registrar al menos un tipo de información para poder enviar su solicitud.\n';
      errores++;
    }

    if (errores > 0) this.alertDialogService.open(mensage);

    return errores > 0;
  }

  addItem(newItem: ISolicitudDocumentoTecnicoModel) {
  }

  downloadDocumentFromService(element: ISolicitudDocumentoTecnicoModel) {

    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.DocumentacionTecnica;
      modelVisor.idSolicitudDocumento = element.idSolicitudDocumentoTecnico;
      modelVisor.codigoSolicitud = this.itemSolicitud.codigo;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudDocumentoTecnicoService.downloadDocumento(
        this.itemSolicitud.codigo,
        element.idSolicitudDocumentoTecnico
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
